module.exports = __webpack_public_path__ + "static/media/metrotownMenu.3a576b82.pdf";